// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__YqyQj"};